import "./legacy/shims/processEnv.js";
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import App from "./App.jsx";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "./styles/index.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { CompareProvider } from "./hooks/useCompare.jsx";
import { AdminAuthProvider } from "./legacy/context/AdminAuthContext.js";
import { ToastProvider } from "./legacy/components/ToastContext.jsx";
import { CurrencyProvider } from "./legacy/components/CurrencyContext.jsx";
import { BookingProvider } from "./legacy/context/BookingContext.js";
import { SearchProvider } from "./context/SearchContext.jsx";
import ScrollToTop from "./components/ScrollToTop.jsx";
import VisitorActivityTracker from "./components/VisitorActivityTracker.jsx";

const queryClient = new QueryClient();

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <AdminAuthProvider>
          <ToastProvider>
            <CurrencyProvider>
              <BookingProvider>
                <SearchProvider>
                  <CompareProvider>
                    <ScrollToTop />
                    <VisitorActivityTracker />
                    <App />
                  </CompareProvider>
                </SearchProvider>
              </BookingProvider>
            </CurrencyProvider>
          </ToastProvider>
        </AdminAuthProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>
);
